import toggleDialogCreator from "shared/helpers/toggleDialogCreator";
import { get } from "lodash";

export const COMPLETION_DIALOG = "COMPLETION_DIALOG";

export const getCompletionDialogModel = state => {
  return get(state, [
    "dialog",
    "buyer_portal",
    COMPLETION_DIALOG,
    COMPLETION_DIALOG
  ]);
};

export const toggleCompletionDialog = dispatch => {
  const toggle = toggleDialogCreator(
    dispatch,
    COMPLETION_DIALOG,
    "buyer_portal"
  );
  return show => {
    toggle(COMPLETION_DIALOG, show);
  };
};
